import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsTrophy08Small = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M13.118 6.323a.625.625 0 01-.623.677h-.99a.625.625 0 110-1.25h.99c.325 0 .596.25.623.573zM11.5 8.75h1a.75.75 0 010 1.5h-1a.75.75 0 010-1.5z" />
        <path d="M5 0a1 1 0 00-1 1v1H2a2 2 0 00-2 2v4a5 5 0 005 5h1.186a10.986 10.986 0 004.6 3.579l.214.089v1.851l-4.625 3.7A1 1 0 007 24h10a1 1 0 00.625-1.78L13 18.52v-1.852l.214-.089a10.986 10.986 0 004.6-3.579H19a5 5 0 005-5V4a2 2 0 00-2-2h-2V1a1 1 0 00-1-1zm15 4h2v4a3 3 0 01-3 3c.647-1.41 1-2.967 1-4.582zM2 4h2v2.418C4 8.033 4.353 9.59 5 11a3 3 0 01-3-3zm7.138 2.178A2.375 2.375 0 0111.505 4h.99a2.375 2.375 0 011.872 3.837A2.5 2.5 0 0112.5 12h-1a2.5 2.5 0 01-1.867-4.163 2.364 2.364 0 01-.495-1.66z" />
      </g>
    </svg>
  )
);
SvgAchievementsTrophy08Small.defaultProps = {
  color: "currentColor",
  size: 24,
  title: undefined,
  titleId: undefined,
};
SvgAchievementsTrophy08Small.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsTrophy08Small;
